// extracted by mini-css-extract-plugin
module.exports = {"spinner":"_3q8xbTG4aotRgd6r45oikk","load7":"_2v1L7bb31Mhma5TrNsrYiE","small":"_2byrNH9SOfYPY5UEzichgE"};